import { render, staticRenderFns } from "./OrderChart.vue?vue&type=template&id=5426defd&"
import script from "./OrderChart.vue?vue&type=script&lang=js&"
export * from "./OrderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports